<ng-container *ngIf="layoutIsHidden$ | async; then loggedOut; else loggedIn"> </ng-container>

<ng-template #loggedIn>
    <mat-sidenav-container class="sidenav-container" (click)="onSinenavToggle($event)">
        <mat-sidenav #leftSidenav mode="side" opened>
            <app-sidebar></app-sidebar>
        </mat-sidenav>

        <mat-sidenav-content [@onMainContentChange]="onSideNavChange ? 'open': 'close'">
            <div class="main_content aumico-grid">
                <div class="aumico-nested-grid aumico-grid-row-header">
                    <div style="grid-column: 1 / 17">
                        <aum-action-header
                            class="no-space"
                            [breadcrumbItems]="breadcrumbItems"
                            [hasBackButton]="actionHeaderHasBackButton$ | async"
                            [pageHeader]="actionPageHeader$ | async"
                            [hasBackForth]="false"
                            [actionText]="actionText$ | async"
                            [filterText]="filterText$ | async"
                            [searchText]="searchText$ | async"
                        >
                            <aumico-subnavigation
                                [hide]="hideSubNavigation"
                                *ngIf="activeSubNavigation$ | async"
                            ></aumico-subnavigation>
                        </aum-action-header>
                    </div>
                </div>
                <div class="aumico-content-grid aumico-grid-row-content">
                    <ng-container *ngTemplateOutlet="content"></ng-container>
                </div>
                <div
                    class="aumico-nested-grid aumico-grid-row-footer"
                    [ngClass]="{'hidden-footer': hideFooterOption$ | async}"
                >
                    <aumico-action-footer></aumico-action-footer>
                </div>
            </div>
        </mat-sidenav-content>
    </mat-sidenav-container>
</ng-template>

<ng-template #loggedOut>
    <aumico-logged-out-layout>
        <div aumico-logged-out-layout-side-content>
            <ng-content select="[aumico-logged-out-layout-side-content]"></ng-content>
        </div>
        <div aumico-logged-out-footer>
            <ng-content select="[aumico-logged-out-footer]"></ng-content>
        </div>
        <div>
            <ng-container *ngTemplateOutlet="content"></ng-container>
        </div>
    </aumico-logged-out-layout>
</ng-template>

<ng-template #content>
    <ng-content select="[content]"></ng-content>
</ng-template>

<div [ngClass]="{ displayOverlay: blockingRequestIsActive$ | async}" class="progress-overlay">
    Blocking Request is ongoing
</div>
<aum-notification-toast></aum-notification-toast>
